import { ChangeEmail } from "@/features"
import styles from "./styles.module.scss"

export const ChangeEmailPage = () => {
  return (
    <div className={styles.page}>
      <ChangeEmail />
    </div>
  )
}
